import { EDescriptionQualityReason } from 'partner360/entities/keyInitiatives'

import { IDescriptionQualityResult } from './models'

export const DESCRIPTION_QUALITY_CONFIG = {
  showScore: false,
  defaultValue: {
    score: 0,
    reasons: [EDescriptionQualityReason.Empty],
  },
} satisfies {
  showScore: boolean
  defaultValue: IDescriptionQualityResult
}
